export const PRIVILEGE_GRANTED = 'granted';
export const PRIVILEGE_DENIED = 'denied';